
export const LATAM_COUNTRY_CODES = new Set([
  'AR', 'BZ', 'AI', 'AG', 'AW', 'BS', 'BB', 'BM', 'BQ', 'VG', 'KY', 'CW',
  'DM', 'GF', 'GY', 'GP', 'GD', 'HT', 'JM', 'MS', 'MQ', 'KN', 'BL', 'LC',
  'MF', 'VC', 'SR', 'TT', 'TC', 'CO', 'MX', 'BO', 'CR', 'DO', 'EC', 'SV',
  'GT', 'HN', 'NI', 'PA', 'PY', 'PE', 'UY', 'VE', 'FK', 'GS',
  // Códigos históricos/edge incluidos por robustez
  'AN', 'SX',
])

export const SPAIN_COUNTRY_CODE = 'ES'

// Devuelve el tipo de modal de geobloqueo según el código de país (country_code2):
//   'none'  → Chile o sin dato: no se muestra ninguna modal.
//   'latam' → Latinoamérica (sin Chile) + España: modal regional.
//   'world' → resto del mundo: modal actual.
export const getGeoModalType = (countryCode) => {
  if (!countryCode) {
    return 'none'
  }
  const code = String(countryCode).trim().toUpperCase()
  if (!code || code === 'CL') {
    return 'none'
  }
  if (code === SPAIN_COUNTRY_CODE || LATAM_COUNTRY_CODES.has(code)) {
    return 'latam'
  }
  return 'world'
}